<template>
    <div class="employees-update-modal">
        <ModalContainer :title="$t('employees.edit_employee')" identifier="employees-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">

                <FormGroupTwo >
                    <FormInputText v-model="$v.employee.name.$model" identifier="name" :label="$t('employees.name')"
                                   :disabled="is_loading_original || is_saving" :has-error="$v.employee.name.$error">
                        <template v-slot:errors>
                            <p v-if="!$v.employee.name.required">
                                {{$t('validation.x_is_required',{x: $t('employees.name')})}}
                            </p>
                        </template>
                    </FormInputText>
                    <FormInputText v-model="$v.employee.email.$model" identifier="email" :label="$t('employees.email')"
                                   :disabled="is_loading_original || is_saving" :has-error="$v.employee.email.$error" autocomplete="off">
                        <template v-slot:errors>
                            <p v-if="!$v.employee.email.required">
                                {{$t('validation.x_is_required',{x: $t('employees.email')})}}
                            </p>
                            <p v-else-if="!$v.employee.email.email">
                                {{$t('auth.enter_valid_email')}}
                            </p>
                        </template>
                    </FormInputText>
                </FormGroupTwo>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import _ from 'lodash';
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";
    import LoadingScreen from "@/components/LoadingScreen";

    export default {
        name: "EmployeesUpdateModal",
        components: {
            LoadingScreen, FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        props: {
            employee_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                original: null,
                employee: {
                    name: null,
                    email: null,
                },
                is_saving: false,
                is_loading_original: false,
            }
        },
        validations: {
            employee: {
                name: {required},
                email: {required, email},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('employees-update-modal', status);
            },
            save() {
                this.$v.employee.$touch();
                if (this.$v.employee.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                let payload = {}

                if (this.original.attributes.name !== this.$v.employee.name.$model)
                    payload.name = this.$v.employee.name.$model;

                if (this.original.attributes.email !== this.$v.employee.email.$model)
                    payload.email = this.$v.employee.email.$model;

                this.$axios.patch(`employees/${this.employee_id}`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('employees.success_updated'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('employees.error_update')),
                        type: 'error',
                    });
                });
            },
            populate() {
                if (!this.original || !this.employee)
                    return;

                this.$v.employee.name.$model = this.original.attributes.name;
                this.$v.employee.email.$model = this.original.attributes.email;
            },
            async retrieveOriginalEmployee() {
                this.is_loading_original = true;

                await this.$axios.get(`employees/${this.employee_id}`)
                    .then(({data}) => {
                        this.original = data.data;
                        this.is_loading_original = false;
                    })
                    .catch(e => {
                        this.is_loading_original = false;

                        this.$notify({
                            title: this.$t('error'),
                            text: this.$larerror(e.response.data, this.$t('employees.error_retrieve')),
                            type: 'error',
                        });
                    });
            },
        },
        async mounted() {
            await this.retrieveOriginalEmployee();
            this.populate();
        }
    }
</script>
